import Header from './components/Header';
import Hero from './components/Hero';
import { SectionTopics, SectionFeatures, SectionRanking } from './components/SectionsA';
import { SectionCards, SectionMedia, SectionComments } from './components/SectionsB';
import { SectionContact, SectionApp, SectionCarousel, SectionAbout, SectionIndex } from './components/SectionsC';
import { SectionUpdates, SectionFaq } from './components/SectionsD';
import Footer from './components/Footer';
import type { FC } from 'react';

const Home: FC = () => {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <SectionTopics />
        <SectionFeatures />
        <SectionRanking />
        <SectionCards />
        <SectionMedia />
        <SectionComments />
        <SectionContact />
        <SectionApp />
        <SectionCarousel />
        <SectionAbout />
        <SectionIndex />
        <SectionUpdates />
        <SectionFaq />
      </main>
      <Footer />
    </>
  );
};

export default Home;